import React from 'react'
import './index.css';
import Property6 from '../../../component/Explore/Propertypage'

const Property = () => {
  return (
    <div>
      <Property6 num="+91-2934572" type="Duplex Rustic Room" desc="Come and enjoy the experience of a duplex rustic room with your family. Enjoy the vibe of a vibrant weather and a cosy location." roomdesc = "Pre-Book Your room for your partner , family or friends to enjoy the seamless checkin." price = "1900" guests="4" bed="2"  bath="2"/>
    </div>
  )
}

export default Property
